import { createPostEndpoint } from '@sonar-software/sonar-http';
import { StakeholderType } from '@types';

export type PostStakeholderRequest = {
	email: string;
	name: string;
	stakeholderType: StakeholderType;
};

export type PostStakeholderResponse = {
	stakeholderId: number;
};

export const postStakeholder = createPostEndpoint<PostStakeholderRequest, PostStakeholderResponse>(
	'/api/v3/core/stakeholders'
);
